"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuMobile = void 0;
const React = require("react");
const react_native_1 = require("react-native");
const react_native_drawer_layout_1 = require("react-native-drawer-layout");
const theme_1 = require("../modules/theme");
const layout_1 = require("../modules/layout");
const Menu_1 = require("./Menu");
class MenuMobile extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            opened: false
        };
        this.drawer = null;
        this.handleBackButton = () => {
            if (this.state.opened) {
                this.close();
                return true;
            }
            return false;
        };
        this.handleMenuPress = (path) => {
            this.close();
            this.props.onMenuPress(path);
        };
        this.open = () => {
            if (this.drawer) {
                this.drawer.openDrawer();
            }
        };
        this.close = () => {
            if (this.drawer) {
                this.drawer.closeDrawer();
            }
        };
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                container: {
                    flex: 1
                },
                logoContainer: {
                    paddingVertical: 5,
                    paddingLeft: 10,
                    borderBottomColor: theme.borderColor1,
                    borderBottomWidth: 1,
                    flexDirection: 'row'
                },
                userContainer: {
                    paddingVertical: 10,
                    paddingLeft: 20,
                    paddingRight: 10,
                    borderBottomColor: theme.borderColor1,
                    borderBottomWidth: 1
                },
                menuContainer: {
                    paddingLeft: 20,
                    flex: 1
                }
            });
            return styles;
        };
        this.renderNavigationView = () => {
            const { renderLogo, renderUserData, menu, isCurrentMenuPath } = this.props;
            const styles = this.getStyles();
            return (React.createElement(react_native_1.View, { style: styles.container },
                React.createElement(react_native_1.View, { style: styles.logoContainer }, renderLogo()),
                renderUserData && (React.createElement(react_native_1.View, { style: styles.userContainer }, renderUserData())),
                React.createElement(react_native_1.ScrollView, { style: styles.menuContainer },
                    React.createElement(Menu_1.Menu, { menu: menu, isCurrentMenuPath: isCurrentMenuPath, onMenuPress: this.handleMenuPress }))));
        };
    }
    componentDidMount() {
        react_native_1.BackHandler.addEventListener('hardwareBackPress', this.handleBackButton);
    }
    componentWillUnmount() {
        react_native_1.BackHandler.removeEventListener('hardwareBackPress', this.handleBackButton);
    }
    render() {
        const theme = (0, theme_1.getTheme)();
        return (React.createElement(react_native_drawer_layout_1.default, { ref: drawer => (this.drawer = drawer), drawerLockMode: this.props.drawerLockMode, drawerBackgroundColor: theme.backgroundColor1, drawerWidth: (0, layout_1.isTablet)() ? 450 : 300, drawerPosition: react_native_drawer_layout_1.default.positions.Left, renderNavigationView: this.renderNavigationView, onDrawerOpen: () => this.setState({ opened: true }), onDrawerClose: () => this.setState({ opened: false }) }, this.props.children));
    }
}
exports.MenuMobile = MenuMobile;
